import { useEffect } from 'react';
import { applyPageSeo, type PageSeoInput } from './applyPageSeo';

export type UsePageSeoInput = PageSeoInput & {
  /** Si false, n'applique pas les meta (ex. RouteSeo sur /shop/:slug). */
  enabled?: boolean;
};

/** Met à jour les balises head à chaque changement de props SEO. */
export function usePageSeo(input: UsePageSeoInput) {
  const {
    title,
    description,
    path,
    canonical,
    image,
    imageAlt,
    type,
    noindex,
    lang,
    hreflang,
    enabled = true,
  } = input;

  useEffect(() => {
    if (!enabled) return;
    applyPageSeo({
      title,
      description,
      path,
      canonical,
      image,
      imageAlt,
      type,
      noindex,
      lang,
      hreflang,
    });
  }, [enabled, title, description, path, canonical, image, imageAlt, type, noindex, lang, hreflang]);
}
